import {
  TradeTicketEntity,
  TradeTicketDetailEntity,
} from "@goodfill/domain-entities";
import {
  asTradeTicketId,
  asAccountId,
  asOrderTicketId,
  asAmount,
  asBondPriceNominal,
  asYield,
} from "@goodfill/domain-properties";
import Decimal from "decimal.js";
import { TradeTicket } from "../API";
import { createDateTimeFromAwsDate } from "../date/awsDateFormat";
import { assertIsDecimalFinite } from "../number/assertIsDecimalFinite";
import { orderTicketApiToModel } from "../orderTicket/OrderTicket";

export function tradeTicketApiToModel(
  apiTradeTicket: TradeTicket
): TradeTicketEntity {
  const amount = new Decimal(apiTradeTicket.amount);
  assertIsDecimalFinite(amount, "amount");

  const bondPrice = new Decimal(apiTradeTicket.bondPrice);
  assertIsDecimalFinite(bondPrice, "bondPrice");

  const accruedInterest = new Decimal(apiTradeTicket.accruedInterest);
  assertIsDecimalFinite(accruedInterest, "accruedInterest");

  const finalCommissionAmount = new Decimal(
    apiTradeTicket.finalCommissionAmount
  );
  assertIsDecimalFinite(finalCommissionAmount, "finalCommissionAmount");

  const loadedYield = new Decimal(apiTradeTicket.loadedYield);
  assertIsDecimalFinite(loadedYield, "loadedYield");

  return {
    id: asTradeTicketId(apiTradeTicket.id),
    accountId: asAccountId(apiTradeTicket.accountId),
    orderTicketId: asOrderTicketId(apiTradeTicket.orderTicketId),
    amount: asAmount(amount),
    bondPrice: asBondPriceNominal(bondPrice),
    accruedDays: apiTradeTicket.accruedDays,
    accruedInterest: asAmount(accruedInterest),
    tradeDate: createDateTimeFromAwsDate(
      apiTradeTicket.tradeDate,
      "apiTradeTicket.tradeDate"
    ),
    settlementDate: createDateTimeFromAwsDate(
      apiTradeTicket.settlementDate,
      "apiTradeTicket.settlementDate"
    ),
    isClosed: apiTradeTicket.isClosed ?? null,
    finalCommissionAmount: asAmount(finalCommissionAmount),
    loadedYield: asYield(loadedYield),
  };
}

export function tradeTicketDetailApiToModel(
  apiTradeTicket: TradeTicket
): TradeTicketDetailEntity {
  return {
    ...tradeTicketApiToModel(apiTradeTicket),
    orderTicket: orderTicketApiToModel(apiTradeTicket.orderTicket),
  };
}
